// Safe service-worker registration with controlled updates. Exposes an "update available"
// callback so the UI can prompt the user (we never auto-skipWaiting). Recovers from a broken
// controller by allowing a manual update apply.
let waitingWorker: ServiceWorker | null = null;
let onUpdate: (() => void) | null = null;
let updateApplied = false;

export function onUpdateAvailable(cb: () => void) {
  onUpdate = cb;
  if (waitingWorker) cb();
}

export function applyUpdate() {
  if (waitingWorker) {
    updateApplied = true; // only THEN do we reload on controllerchange
    waitingWorker.postMessage({ type: "SKIP_WAITING" });
  }
}

export function clearApiCache() {
  navigator.serviceWorker?.controller?.postMessage({ type: "CLEAR_API_CACHE" });
}

export function registerSW() {
  if (!("serviceWorker" in navigator)) return;
  if (process.env.NODE_ENV === "test") return;
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").then((reg) => {
      if (reg.waiting && navigator.serviceWorker.controller) {
        waitingWorker = reg.waiting;
        onUpdate?.();
      }
      reg.addEventListener("updatefound", () => {
        const installing = reg.installing;
        if (!installing) return;
        installing.addEventListener("statechange", () => {
          if (installing.state === "installed" && navigator.serviceWorker.controller) {
            waitingWorker = reg.waiting || installing;
            onUpdate?.();
          }
        });
      });
    }).catch(() => { /* SW unavailable — app still works online */ });

    let reloaded = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (!updateApplied || reloaded) return; // ignore the first-load clients.claim()
      reloaded = true;
      window.location.reload();
    });
  });
}
